import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import * as JsEncryptModule from 'jsencrypt';
import * as jsSHA from 'jssha';
import * as moment from 'moment';
import * as forge from 'node-forge';
import { BehaviorSubject, Observable, Observer, Subject } from 'rxjs';
import { PatientsearchService } from '../home/patientsearch.service';
import { MaterialDialogComponent } from '../matdialog/matdialog.component';
import { SnackBarService } from '../snackbar/snack-bar.service';
import { DiseasesService } from './diseases.service';

declare var $: any;

@Injectable()
export class SharedService {
  constructor(
    private title: Title,
    private router: Router,
    private dialog: MatDialog,
    private http: HttpClient,
    private snack: SnackBarService,
    private userIdle: UserIdleService,
    private locationStrategy: LocationStrategy,
    private sanitizer: DomSanitizer,
    private patientService: PatientsearchService,
    private diseasesService: DiseasesService
  ) {
  }
  loadleftPanel: EventEmitter<any> = new EventEmitter();
  showLeftPanel: EventEmitter<any> = new EventEmitter();
  showExamination: EventEmitter<any> = new EventEmitter();
  clearNameInSearch: EventEmitter<any> = new EventEmitter();
  updateMatTabIndex: EventEmitter<any> = new EventEmitter();
  highlightActiveTab: EventEmitter<any> = new EventEmitter();
  loadInvestigationData: EventEmitter<any> = new EventEmitter();
  selectedIndexForTabChange: EventEmitter<any> = new EventEmitter();
  populateEnrollmentFacilityData: EventEmitter<any> = new EventEmitter();
  headerBackButtonClicked: EventEmitter<any> = new EventEmitter();
  healthIdUpdate: EventEmitter<any> = new EventEmitter();
  memberActive: boolean;
  previousRoute: any;
  scLogin: boolean = false;
  choLogin: boolean = false;
  private isLoading$$ = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading$$.asObservable();
  private isCbacCompleted$$ = new BehaviorSubject<boolean>(null);
  isCbacCompleted$ = this.isCbacCompleted$$.asObservable();
  callTokenFunction: any;
  searchInfo = {
    searchText: null,
    searchData: [],
    suggestionNote: false,
    loadMore: false,
    offset: 0
  }
  patientfamilydata = []
  searchPayloadInfoWeb = {}
  searchresultWeb = {
    results : [],
    hasTooManyRecords: false
  }
  refreshTokenApiInProgress = false;
  skipPwaBackHistory = true;
  workplanFilterObj = {
    workplanFilteredData: {},
    workplanSelectedTab: {
      showPriorityTab: true,
      showReferralsTab: false,
      showIncompletePatientTab: false,
    },
    workplanSelectedItems: [],
    workplanOffset: 0,
  }  
  workplanDetails = {
    isWorkplan : false,
    workplanPage : ""
  };
  savedWorkplanFilterObj = {
    type: "",
    subcenter: null,
    village: null,
    taluk: null,
    phc: null,
    fromDateFollowUp: null,
    endDateFollowUp: null
  };
  workplanPageOffset = 0;
  isNotMobile() {
    const ua = navigator.userAgent;
    if (this.isTablet()) {
      return true;
    }
    if (/Mobile|iP(hone)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return false;
    }
    return true;
  }

  isTablet() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    );
  }

  isMobile() {
    if (!this.isTablet()) {
      const ua = navigator.userAgent;
      if (/Mobile|iP(hone)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return true;
      }
    }
    return false;
  }

  isLoggednIn() {
    return this.isValidString(sessionStorage.getItem('access_token'));
  }

  public isValidString(value: any): boolean {
    return 'string' === typeof value && 0 < value.length;
  }

  closeModalAndDialogs() {
    $('.modal').modal('hide');
    this.dialog.closeAll();
  }

  isNumber(evt, decimalAllowed?) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (decimalAllowed && charCode === 46) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onlyAlphaNumerics(evt, t) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;

    if (charCode === 0 || charCode === 8) {
      return true;
    } else if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
      return true;
    } else if (charCode >= 48 && charCode <= 57) {
      return true;
    } else {
      return false;
    }
  }

  isAlphabets(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
      return true;
    } else {
      return false;
    }
  }

  validateAadhar(aadharNumber) {
    if (aadharNumber.match(/^[0-9]+$/)) {
      const d = [
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
          [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
          [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
          [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
          [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
          [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
          [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
          [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
          [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
        ],
        // permutation table
        p = [
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
          [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
          [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
          [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
          [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
          [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
          [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
        ];

      // validates Aadhar number received as string
      let c = 0;
      const invertedArray = aadharNumber.split('').map(Number).reverse();

      invertedArray.forEach((val, i) => {
        c = d[c][p[i % 8][val]];
      });

      return c === 0;
    }
    return true;
  }

  showInfoMsg(message?) {
    message =
      message ||
      'Vitals and information seen below have been collected previously on the date shown. Please update if needed.';
    this.snack.openSnackBar(message, this.isNotMobile(), 'info');
  }

  showInfoMsgforCBAC(message?) {
    message =
      message ||
      '';
    this.snack.openSnackBar(message, this.isNotMobile(), 'info', '', true);
  }

  showSuccessMsg(msg) {
    this.snack.openSnackBar(msg, this.isNotMobile(), 'success');
  }
  showErrMsg(msg) {
    this.snack.openSnackBar(msg, this.isNotMobile(), 'error');
  }
  showErrorMsg(error?) {
    let trackingId = null;
    try {
      trackingId = error.headers.get('x-request-id');
    } catch(err) {
    }
    this.snack.openSnackBar(this.returnErrorMessage(error), this.isNotMobile(), 'error', trackingId);
  }
  returnErrorMessage(error) {
    let msg = 'Application is currently not responding. Please try after sometime.';
    if (error && error.status !== 500) {
      if (error && error.error) {
        if (error.error.error_description && typeof error.error.error_description === 'string') {
          msg = error.error.error_description;
          if (typeof error.error.error === 'string') {
            if (error.error.error.toLowerCase() === 'invalid_token') {
              this.redirectToLogin();
            }
          }
        } else if (error.error.text && typeof error.error.text === 'string') {
          msg = error.error.text;
        } else if (error.error.message && typeof error.error.message === 'string') {
          msg = error.error.message;
        } else if (error.message && typeof error.message === 'string') {
          msg = error.message;
        } else if (error.error.error && typeof error.error.error === 'string') {
          msg = error.error.error;
        }
      }
    }
    return msg;
  }

  openInvestigationModal() {
    this.dialog.open(MaterialDialogComponent, {
      data: {
        title: 'Coming soon on mobile !',
        content: 'Please use the web portal to order Investigations.',
        yesButtonName: 'OK',
      },
    });
  }

  private screeningObj = new BehaviorSubject<any>('');
  setrescreeningData(res) {
    if(res) {
      this.screeningObj.next(res);
    }
  }
  getRescreeningData() {
    return this.screeningObj.asObservable();
  }

  updateTitle(title: string) {
    this.title.setTitle(title);
  }

  scrollToError() {
    setTimeout(() => {
      $('html, body').animate(
        {
          scrollTop: $('.error') && $('.error').length ? $('.error').offset().top - 300 : 0,
        },
        1000
      );
    });
  }

  scrollToAreaMap(scroll) {
    setTimeout(() => {
      $('html, body').animate(
        {
          scrollTop: document.body.scrollHeight * scroll,
        },
        1000
      );
    });
  }

  scrollToTop() {
    setTimeout(() => {
      $('html, body').animate(
        {
          scrollTop: 0,
        },
        1000
      );
    });
  }
  getLocationParams() {
    return {
      facilityType: sessionStorage.getItem('facilityType'),
      facilityTypeId: sessionStorage.getItem('facilityTypeId'),
      facilityId: sessionStorage.getItem('facilityId'),
      facilityName: sessionStorage.getItem('facilityName'),
      cdssType: sessionStorage.getItem('cdssType'),
      loginuser: sessionStorage.getItem('loginuser'),
      isIAVisible: sessionStorage.getItem('isIAVisible'),
      authorities: sessionStorage.getItem('authorities'),
      covidType: sessionStorage.getItem('covidType'),
      stateCode: sessionStorage.getItem('stateCode'),
    };
  }

  isScreeningNumberExists(data, diseaseId) {
    return data[diseaseId] && data[diseaseId][0] && data[diseaseId][0].screeningId;
  }

  filterNonScreenedDisease(nonScreenedDiseases, gender) {
    return nonScreenedDiseases.filter((disease) => {
      return (
        disease.name.toLowerCase() === 'hypertension' ||
        disease.name.toLowerCase() === 'diabetes' ||
        (gender === 'Male' || gender === 'M'
          ? disease.name.toLowerCase() === 'oral'
          : disease.name.toLowerCase() === 'oral' ||
            disease.name.toLowerCase() === 'breast' ||
            disease.name.toLowerCase() === 'cervical')
      );
    });
  }

  returnDiseaseArray(isSummary?) {
    let diseaseArray = [];
    if (!isSummary) {
      diseaseArray = [
        {
          screeningId: null,
          diseaseId: null,
          diseaseName: this.isMobile() ? 'Personal Exam*' : 'Personal Examination*',
          key: 'personalExamination',
          isActive: false,
          disabled: false,
          imgUrl: 'src/app/assets/images/screening/personal_examination.png',
          mobImgUrl: 'src/app/assets/images/screening/personal_examination_mob.png',
          isApplicableForAll: true,
          status: null,
          color: null,
        },
        {
          screeningId: null,
          diseaseId: null,
          diseaseName: this.isMobile() ? 'Personal Hist' : 'Personal History',
          key: 'personalHistory',
          isActive: false,
          disabled: false,
          imgUrl: 'src/app/assets/images/screening/personal_history.png',
          mobImgUrl: 'src/app/assets/images/screening/personal_history_mob.png',
          isApplicableForAll: true,
          status: null,
          color: null,
        },
      ];
    }
    diseaseArray.push(
      {
        screeningId: null,
        diseaseId: '500',
        diseaseName: 'Hypertension',
        key: 'Hypertension',
        isActive: false,
        disabled: false,
        imgUrl: isSummary
          ? 'src/app/assets/images/assessment/mobile/ico_hypertension_card.png'
          : 'src/app/assets/images/el_hypertension.png',
        mobImgUrl: 'src/app/assets/images/el_hypertension_mob.png',
        isApplicableForAll: true,
        status: null,
        color: null,
      },
      {
        screeningId: null,
        diseaseId: '600',
        diseaseName: 'Diabetes',
        key: 'Diabetes',
        isActive: false,
        disabled: false,
        imgUrl: isSummary
          ? 'src/app/assets/images/assessment/mobile/ico_diabetes_card.png'
          : 'src/app/assets/images/el_diabetes.png',
        mobImgUrl: 'src/app/assets/images/el_diabetes_mob.png',
        isApplicableForAll: true,
        status: null,
        color: null,
      },
      {
        screeningId: null,
        diseaseId: '100',
        diseaseName: 'Oral Cancer',
        key: 'Oral',
        isActive: false,
        disabled: false,
        imgUrl: isSummary
          ? 'src/app/assets/images/assessment/mobile/ico_oral_cancer_card.png'
          : 'src/app/assets/images/cancers/oral-screening.png',
        mobImgUrl: 'src/app/assets/images/cancers/oral-screening-mob.png',
        isApplicableForAll: true,
        status: null,
        color: null,
      },
      {
        screeningId: null,
        diseaseId: '200',
        diseaseName: 'Breast Cancer',
        key: 'Breast',
        isActive: false,
        disabled: false,
        imgUrl: isSummary
          ? 'src/app/assets/images/assessment/mobile/ico_breast_cancer_card.png'
          : 'src/app/assets/images/cancers/breast-screening.png',
        mobImgUrl: 'src/app/assets/images/cancers/breast-screening-mob.png',
        isApplicableForAll: false,
        status: null,
        color: null,
      },
      {
        screeningId: null,
        diseaseId: '300',
        diseaseName: 'Cervical Cancer',
        key: 'Cervical',
        isActive: false,
        disabled: false,
        imgUrl: isSummary
          ? 'src/app/assets/images/assessment/mobile/ico_cervical_cancer_card.png'
          : 'src/app/assets/images/cancers/cervical-screening.png',
        mobImgUrl: 'src/app/assets/images/cancers/cervical-screening-mob.png',
        isApplicableForAll: false,
        status: null,
        color: null,
      }
    );
    return diseaseArray;
  }

  downloadAttachment(individualId, testId, testOrderId, testObj) {
    this.getImage(individualId, testId, testOrderId, testObj).subscribe((imageData) => {
      const tmpUrl = URL.createObjectURL(new Blob([imageData])),
        link = document.createElement('a');
      link.href = tmpUrl;
      link.download = testObj;
      link.click();
    });
  }

  getImage(individualId, testId, testOrderId, testObj) {
    return Observable.create((observer) => {
      const req = new XMLHttpRequest();
      req.open(
        'get',
        '/cphm/lab/generalLabTestFile/individual/' +
          individualId +
          '/labTestId/' +
          testId +
          '/orderId/' +
          testOrderId +
          '/file/' +
          testObj +
          '/download'
      );
      req.responseType = 'arraybuffer';
      req.setRequestHeader('txnUser', sessionStorage.getItem('loginuser'));
      req.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.getItem('access_token'));
      req.setRequestHeader('facilityType', sessionStorage.getItem('facilityType'));
      req.setRequestHeader('facilityTypeId', sessionStorage.getItem('facilityTypeId'));
      req.setRequestHeader('isCdssFacility', sessionStorage.getItem('cdssType'));

      req.onreadystatechange = function () {
        if (req.readyState === 4 && req.status === 200) {
          observer.next(req.response);
          observer.complete();
        }
      };
      req.send();
    });
  }

  refreshTokenAPI(data) {
    return this.http.post('/cphm/oauth/token', 'grant_type=refresh_token&refresh_token=' + data.accessToken, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Authorization', 'Basic TkNEQnJvd3NlcjpTZWN1cmVOQ0Q=')
        .set('txnUser', ''),
    });
  }

  refreshToken() {
    if (sessionStorage.getItem('refresh_token')) {
      const reqObj = {
        grant_type: 'refresh_token',
        accessToken: sessionStorage.getItem('refresh_token'),
      };
      sessionStorage.setItem('refreshOnLoad', JSON.stringify(true));
      if(this.refreshTokenApiInProgress) {
        return;
      }
      this.refreshTokenApiInProgress = true;
      this.refreshTokenAPI(reqObj).subscribe(
        (res: any) => {
          if (res && res.access_token && res.refresh_token) {
            this.refreshTokenApiInProgress = false;
            sessionStorage.setItem('access_token', res.access_token);
            sessionStorage.setItem('refresh_token', res.refresh_token);
            sessionStorage.setItem('refreshOnLoad', JSON.stringify(false));
          } else {
            this.redirectToLogin();
          }
        },
        (err) => {
          this.showErrorMsg(err);
        }
      );
    } else {
      this.redirectToLogin(true);
    }
  }


  redirectToLogin(gotoLoginPage?: boolean) {
    sessionStorage.clear();
    this.scLogin = false;
    this.userIdle.stopWatching();
    this.searchInfo.searchData = []
    if(gotoLoginPage) {
      this.router.navigate(['/login']);
    } else {
      window.open(window.location.origin, '_parent');
    }
    
  }

  getValue(name) {
    if (window.location.hostname === 'localhost') {
      return this.getCookie(name);
    } else {
      return sessionStorage.getItem(name);
    }
  }

  getCookie(cname) {
    const name = cname + '=',
      ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  setCookie(cname, cvalue) {
    document.cookie = cname + '=' + cvalue + ';';
  }
  encryptValue(value) {
    // Salt is created using username bytes as input to create message digest using SHA-256 hash function and finally converting the resultant bytes in hexadecimal.
    const hashValue = new jsSHA('SHA-256', 'TEXT', { numRounds: 1 });
    hashValue.update(value);
    return hashValue.getHash('HEX');
  }

  encryptPwdWithRSA(usernameSalt, passwordSalt) {
    const publicKey =
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArt+zXeqmeox3dBmxKK5X7mfmZJjupftpO+e7KFbJf0esUYV0aWc3Of6Sm4XVqa+jwnsINuFhorjK+k8kPmW7f2iDjTM9zKV6los0bQQS9czBiK1QRGreg9fPE/+CwM+rYKwm1HEGW6ynN17yWunYtuniZWfZLkiI7EW76ISkpfTPEUXFFwcDGgxMVALRSVwwz/C6WGXSi1jxJGBlGoMxmr7IhmPJXx9YPfLRFkIwzgY7D+pqHiprqK99PBwN+MpUH1t4XKK7HB10FpSGSU/61ZGeC+RjRMLrWQaXyow5VUsjfZ5Aldpk1JAJSo1xBh6EZrWK7I8qvUudbqcfiW0bVwIDAQAB',
      encrypt = new JsEncryptModule.JSEncrypt();

    encrypt.setPublicKey(publicKey);
    return window.btoa(encrypt.encrypt(usernameSalt + ':' + passwordSalt + ':' + new Date().getTime()).toString());
  }

  preventBackButton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    });
  }

  getScreeningNumber(screeningNumber, diseaseId) {
    for (const key in screeningNumber) {
      if (screeningNumber.hasOwnProperty(key)) {
        if (
          key === diseaseId &&
          screeningNumber[key] &&
          screeningNumber[key][0] &&
          screeningNumber[key][0].screeningId
        ) {
          return screeningNumber[key][0].screeningId;
        }
      }
    }
  }
  encryptAadharWithRSA(aadhaar) {
    if (aadhaar) {
      const publicKey =
          '-----BEGIN PUBLIC KEY-----' +
          'MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAvs4rMPei5NK9de+DUum6FCBOa4sxRB4/RUC9AIjr7rt/' +
          'NqTFT7Xe9yOewgqiQ5Y5tIvHfTH9uokm7+KluyMZ+ppBCCxQp3HSm20BqlflP62VkhaXVZ1wmTPJkfrYjdve7p/' +
          'J03ORndsSVk+6EFuPxBhw7z72LLh18KFrFzOZDEIxcMl78r+RvPqC7q2j5sRGawIPeCy0E/5wRbh1R/NRhWPGul/' +
          'm22JgVNathjdO9lmcc44uebcY4MyVf1BMP3eGT1KUMDeZYcoSoMF' +
          '+6zxgO8yFQ0xB6zja6IPOFsMUH536ad6Xh2NQWxKkxuzlThxiy8RIDx7lMqK5uzWSVocmypQBjA9IEmDfKYbWPjfJxMD' +
          '5TWRqhdPFur70Rc4fb0pbjpp388l457+R8tY6o56alNmaRebBtUmCk1CdHePauF4UrvoURmc+vI0Z45Tpi/' +
          'hFmIwSC6YxjJ33mXy1tuN58V7gTZxK/bIMmqsoHphwDc1QN46z6vnCoZJTvffMeqHFeQVYndSTQEdTCCD' +
          '+ROGDdG0aENKigGacrVzhEPywvF41i2rVC27FqBE7BLhS3CIr0uQ6OzwSil1RliFcJN1B8VJDvk/' +
          '6Uxdadwy1TERkOIFw0Mv0x6IKDTxhHu7I' +
          '+9FzuXB0dl5Vvg9qesZfNVgof6VXp451b5NmlfUsu52EmcMCAwEAAQ==' +
          '-----END PUBLIC KEY-----',
        pem = forge.pki.publicKeyFromPem(publicKey),
        encrypted = pem.encrypt(aadhaar, 'RSA-OAEP', {
          md: forge.md.sha1.create(),
          mgf1: {
            md: forge.md.sha1.create(),
          },
        }),
        len = aadhaar.length;
      return {
        idValue: window.btoa(encrypted),
        maskedValue: new Array(len - 3).join('X') + aadhaar.substring(len - 4, len),
      };
    }
    return null;
  }

  encryptOtherIDs(idValue) {
    if (idValue) {
      return { idValue: idValue, maskedValue: null };
    }
    return null;
  }

  getBase64ImageFromURL(url: string) {
    return Observable.create((observer: Observer<string>) => {
      // create an image object
      const img = new Image();
      img.crossOrigin = '*';
      img.src = url + '?' + new Date().getTime();
      if (!img.complete) {
        // This will call another method that will create image from url
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    // We create a HTML canvas object that will create a 2d image
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    // This will draw image
    ctx.drawImage(img, 0, 0);
    // Convert the drawn image to Data URL
    const dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }

  onlyAlphabetsWithSpace(evt, d) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;

    if (charCode === 0 || charCode === 8 || charCode === 46) {
      return true;
    }

    if (charCode === 32) {
      return true;
    }
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
      return true;
    } else {
      return false;
    }
  }

  sanitizeImage(patientdetails) {
    if (patientdetails && patientdetails.photo) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + patientdetails.photo);
    } else {
      return (
        'src/app/assets/images/icon_default_' +
        (patientdetails.gender === 'M' || patientdetails.gender === 'Male'
          ? 'male'
          : patientdetails.gender === 'F' || patientdetails.gender === 'Female'
          ? 'female'
          : 'other') +
        '.png'
      );
    }
  }

  unregisterServiceWorker(url) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (const registration of registrations) {
        registration.unregister();
      }
      window.open(url, '_parent');
    });
  }

  showAddExamination() {
    if (this.isNotMobile()) {
      const patientDetails = JSON.parse(sessionStorage.getItem('patientsummary'));
      if (
        (!this.scLogin &&
          patientDetails.screeningNumber &&
          (patientDetails.gender === 'M' || patientDetails.gender === 'Male') &&
          Object.keys(patientDetails.screeningNumber).length < 4) ||
        (patientDetails.gender !== 'M' &&
          patientDetails.gender !== 'Male' &&
          Object.keys(patientDetails.screeningNumber).length < 6)
      ) {
        $('#am_addExaminations').modal('show');
      }
    }
  }

  routeToPatientSummary(individualId?) {
    if (!individualId) {
      if (!JSON.parse(this.getLocationParams().isIAVisible)) {
        this.router.navigate(['/portal/patientsummary/Profile']);
      } else {
        this.router.navigate(['/portal/patientsummary/patientHistory']);
      }
    } else {
      const patientdetails = JSON.parse(sessionStorage.getItem('patientsummary'));
      this.patientService.getScreeningData(individualId).subscribe((responseList: any) => {
        patientdetails.screeningNumber = responseList;
        sessionStorage.setItem('patientsummary', JSON.stringify(patientdetails));
        if (!JSON.parse(sessionStorage.getItem('generateHealthId'))) {
          if (JSON.parse(this.getLocationParams().isIAVisible)) {
            this.router.navigate(['/portal/patientsummary/patientHistory']);
          } else {
            const screeningIdArray = [];
            let index;
            sessionStorage.setItem('isIAVisible', 'false');
            (<any>Object).values(responseList).forEach(function (d, i) {
              if (d[0].screeningId) {
                index = i;
                screeningIdArray.push(d[0].screeningId);
              }
            });
            if (!screeningIdArray.length || screeningIdArray.length > 1 || this.scLogin) {
              this.router.navigate(['/portal/patientsummary/Profile']);
            } else if (screeningIdArray.length === 1) {
              switch (Object.keys(responseList)[index]) {
                case '100':
                  this.updateRoute('Oral');
                  break;
                case '200':
                  this.updateRoute('Breast');
                  break;
                case '300':
                  this.updateRoute('Cervical');
                  break;
                case '600':
                  this.updateRoute('Diabetes');
                  break;
                case '500':
                  this.updateRoute('Hypertension');
                  break;
                case '900':
                  this.updateRoute('General');
                  break;
                default:
                  break;
              }
            }
          }
        } else {
          this.router.navigate(['/portal/patientsummary/Profile']);
        }
      });
    }
  }

  private updateRoute(disease) {
    this.router.navigateByUrl('/portal/patientsummary/' + disease);
  }

  groupByObject(data, key1, key2) {
    return data.reduce((map, obj) => {
      if (!map[obj[key1]]) {
        map[obj[key1]] = {};
      }

      obj[key2] &&
        [].concat(obj[key2]).forEach((subEl) => {
          if (!map[obj[key1]][subEl]) {
            map[obj[key1]][subEl] = [];
          }

          map[obj[key1]][subEl].push(obj);
        });

      return map;
    }, {});
  }

  checkNullProperties(obj, isEdit?) {
    if (isEdit === true) {
      return false;
    }
    let flag;
    if (Object.keys(obj).length > 1) {
      flag = true;
      for (const key in obj) {
        if (
          key !== 'assesDate' &&
          obj[key] !== null &&
          obj[key] !== undefined &&
          (obj[key].constructor.name === 'Object' || obj[key].length)
        ) {
          if (Object.keys(obj).length > 1) {
            flag = this.checkNullProperties(obj[key], isEdit);
          } else {
            flag = false;
          }
        } else if (key !== 'assesDate' && obj[key] === true) {
          return false;
        }
      }
    }
    return flag;
  }

  setPreviousRoute(url) {
    this.previousRoute = url;
  }

  getPreviousRoute() {
    return this.previousRoute;
  }

  compareDates(date1, date2, date3) {
    const dates = [];
    if (date1) {
      dates.push(new Date(moment(date1, 'DD-MM-YYYY').format('YYYY-MM-DD')));
    }
    if (date2) {
      dates.push(new Date(moment(date2, 'DD-MM-YYYY').format('YYYY-MM-DD')));
    }
    if (date3) {
      dates.push(new Date(moment(date3, 'DD-MM-YYYY').format('YYYY-MM-DD')));
    }
    const maxDate = Math.max.apply(null, dates);
    return moment(maxDate).format('DD-MM-YYYY');
  }
  trimspace(str) {
    return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }

  openFamilyMembers() {
    sessionStorage.setItem('locationHash', JSON.stringify(window.location.hash));
    this.router.navigate(['/portal/patientsummary/Profile']);
  }

  openCBAC() {
    sessionStorage.setItem('locationHash', JSON.stringify(window.location.hash));
    this.router.navigate(['/portal/patientsummary/CBAC']);
  }

  openAddtreatment() {
    this.router.navigate(['/portal/patientsummary/AddTreatment']);
  }

  openScreening(patientdetails) {
    this.diseasesService.getCbacDetails(patientdetails.individualId).subscribe(
      (response: any) => {
        if (response && response.isCbacComplete) {
          this.patientService.getScreeningData(patientdetails.individualId).subscribe(
            (res: any) => {
              if (res) {
                sessionStorage.setItem('locationHash', JSON.stringify(window.location.hash));
                const pdetails = JSON.parse(sessionStorage.getItem('patientsummary'));
                pdetails.screeningNumber = res;
                sessionStorage.setItem('patientsummary', JSON.stringify(pdetails));
                this.router.navigate(['/portal/patientsummary/Screening']);
              }
            },
            (err) => {
              this.showErrorMsg(err);
            }
          );
        } else {
          this.showInfoMsg('Please complete CBAC to start screening.');
        }
      },
      (err) => {
        this.showErrorMsg(err);
      }
    );
  }
  setLoading(isLoading: boolean) {
    this.isLoading$$.next(isLoading);
  }
  setIsCbacCompleted(isCbacComplete: boolean) {
    this.isCbacCompleted$$.next(isCbacComplete);
  }
  loadMedicinesList(query) {
    let medicinesList = new Subject<any>();
    if (query && query.length > 0) {
      this.diseasesService.getmedicinesList(query).subscribe(
        (data: any) => {
          medicinesList.next(data);
          if (data.length === 0) {
            medicinesList.next(query);
          }

          // if (!$scope.showreviewonetreatmentsection) {
          //     $scope.clearAllRadios();
          // }
        },
        (err) => {
          this.showErrorMsg(err);
        }
      );
    }
    return medicinesList.asObservable();
  }
  workplanDateValidation(dateObject) {
    let startDate = moment(dateObject.fromDateFollowUp), endDate = moment(dateObject.endDateFollowUp);
    const diffDate = endDate.diff(startDate, 'days');
    if(diffDate < 0 ||  diffDate > 30) {
      if(dateObject.dateType === 'endDateFollowUp') {
        const fromDate = endDate.subtract(1, 'months');
          if(moment(fromDate).isAfter(dateObject.minDate)) {
            dateObject.fromDateFollowUp = fromDate.toDate();
          } else {
            dateObject.fromDateFollowUp = dateObject.minDate;
          }
      } else {
        const toDate = startDate.add(1, 'months');
        if(moment(dateObject.maxDate).isAfter(toDate)) {
          dateObject.endDateFollowUp = toDate.toDate();
        } else {
          dateObject.endDateFollowUp = dateObject.maxDate;
        }
      }
    }
    return {endDateFollowUp: dateObject.endDateFollowUp, fromDateFollowUp: dateObject.fromDateFollowUp};
  }
  fetchExistingReports() {
    return this.http.get('/cphm/dash-aggregated-ds/v0/apis')
  }
  fetchExistingReportDetails(data) {
    return this.http.post('/cphm/dash-aggregated-ds/v0/reportDetails', data)
  }
  fetchIndividualReport(obj) {
    const url = '/cphm/dash-aggregated-ds/v0/api/report/'+ obj.ids;
    return this.http.post(url, obj, {responseType: 'text', observe: 'response'})
  }
  maskPhoneNumber(phoneNumber: string) {
    const visibleDigits = 3;
    const maskedDigits = phoneNumber.length - visibleDigits;
    return 'x'.repeat(maskedDigits) + phoneNumber.slice(maskedDigits);
  }
  getFinancialYear(date) {
    let getMonth = date.getMonth()
    let getYear = date.getFullYear()
    let endYear, startYear;
    let financialYear = "";
    if(getMonth < 3) {
      endYear = getYear
      startYear = getYear - 1
    } else {
      endYear = getYear + 1
      startYear = getYear
    }
  
    financialYear = startYear + '-' + endYear 

    return financialYear
  }
}